var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultationEncounterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9851 6.97693C20.3051 5.29693 18.9921 4.06993 17.2901 3.52493C16.3651 3.22293 15.3581 3.15193 14.3791 3.31793C13.4871 3.46693 12.6781 4.00193 11.9971 4.49893C11.3411 4.02293 10.5111 3.47793 9.61506 3.32693C8.64806 3.16393 7.64306 3.23193 6.70606 3.52493C2.97606 4.73193 1.82706 8.81393 2.87006 12.0589C4.49406 17.2699 11.4901 20.5839 11.7861 20.7229C11.8531 20.7539 11.9261 20.7699 11.9981 20.7699C12.0701 20.7699 12.1421 20.7539 12.2091 20.7229C12.5011 20.5869 19.3931 17.3319 21.1151 12.0639C21.6661 10.3479 21.6191 8.54093 20.9851 6.97693Z",
    fill: "#33A5B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7446 12.3402H14.1816C14.5956 12.3402 14.9316 12.0042 14.9316 11.5902C14.9316 11.1762 14.5956 10.8402 14.1816 10.8402H12.7446V9.41016C12.7446 8.99616 12.4086 8.66016 11.9946 8.66016C11.5806 8.66016 11.2446 8.99616 11.2446 9.41016V10.8402H9.80859C9.39459 10.8402 9.05859 11.1762 9.05859 11.5902C9.05859 12.0042 9.39459 12.3402 9.80859 12.3402H11.2446V13.7802C11.2446 14.1942 11.5806 14.5302 11.9946 14.5302C12.4086 14.5302 12.7446 14.1942 12.7446 13.7802V12.3402Z",
    fill: "#33A5B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationEncounterIcon);
export default __webpack_public_path__ + "static/media/consultation_encounter_icon.02db897379ece8f95da83998295fdce6.svg";
export { ForwardRef as ReactComponent };